import SpeakersGrid from './SpeakersGrid';

export default SpeakersGrid;
